import { DateTime, Duration } from 'luxon';

export class CommittedOrder {
  id!: string;
  name!: string;
  masterPlanName!: string;
  description?: string;
  distance?: number;
  duration?: Duration;
  jobsCount?: number;
  locationsCount?: number;
  planContainerId?: string;
  status?: number;
  planTypeId?: number;
  distributionLaneId?: string;
  distributionLaneName?: string;
  planTypeName?: string;
  units?: string;
  createdAt: DateTime | null | undefined;
  hasJobFilters?: boolean;
  isPlanRevised?: boolean;
  isScheduled?: boolean;
  day?: number;
}
